import gql from 'graphql-tag'

export const SCROLL = gql`
    query {
        scroll @client
    }
`

export const SHOW_MENU = gql`
    query {
        showMenu @client
        scroll @client
    }
`

export const TOKEN = gql`
    query {
        token @client
    }
`

export const GET_USER = gql`
    query getUser {
        user @client {
            id
            usuario
            nombreCompleto
        }
        type @client
        expiration_date @client
    }
`
export const GET_USER_ACCESS = gql`
    {
        user @client {
            role {
                id
                name
                access {
                    view {
                        id
                        name
                    }
                    create
                    read
                    updated
                    delete
                }
            }
        }    
    }
`

export const GET_ACCESS = gql`
    query getAccess($view:String) {
        getAccess(view: $view) @client {
            create
            read
            updated
            delete
        }
    }
`;

export const GET_USER_LIST = gql`
    query users($cursor:String, $limit:Int) {
        users(cursor: $cursor, limit: $limit) {
            edges {
                id
                firstName
                lastName
                email
                role {
                    id
                    name
                }
            }
            pageInfo {
                endCursor
            }
        }
    }
`

export const GET_USER_BY_ID = gql`
    query userById($id: ID!) {
        user(id: $id) {
            id
            firstName
            lastName
            email
            company {
                id
                name
                address
                phone
            }
            role {
                id
                name
            }
            companies {
                id
                role {
                    id
                }
            }
        }
        companies {
            id
            name
            roles {
                id
                name
            }
        }
    }
`

export const GET_COMPANIES = gql`
    {
        companies {
            id
            name
            roles {
                id
                name
            }
        }
    }
`

